import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'volunteering-all-volunteers-tab-2-part',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './volunteering-all-volunteers-tab-2.part.html',
})

export class VolunteeringAllVolunteersTab2Part {
}
